import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { ReactTinyLink } from 'react-tiny-link'

const BodyParser = ({ postId, body, showPreview }) => {

    const urlRegex = /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,}))\.?)(?::\d{2,5})?(?:[/?#]\S*)?$/i;
    const [bodyParts, setBodyParts] = useState([]);
    const [links, setLinks] = useState([]);

    useEffect(() => {
        var parts = body.split(/(\s+)/); 

        var enhancedParts = [];
        var urls = [];
        var reconstructedString = "";
        parts.map(p => {
            if (p.match(urlRegex)) {
                urls.push(p);
                enhancedParts.push(reconstructedString);
                reconstructedString = "";  
            } else {
                reconstructedString = reconstructedString.concat(p)
            }
        })
        enhancedParts.push(reconstructedString);
        setBodyParts(enhancedParts); 
        setLinks(urls);
    }, [body])

    return (
        <React.Fragment>
            
            {bodyParts.map((p, idx) => {
                return (
                    <React.Fragment key={`body-${postId}-${idx}`} >
                        <React.Fragment>{p}</React.Fragment>
                        {links[idx] &&
                            <a href={links[idx]} target="_blank">{links[idx]}</a>}
                    </React.Fragment>    
                );
            })}

            { showPreview &&
                
                    links.map((l, idx) => {
                        return (
                            <ReactTinyLink key={`bodylink-${postId}-${idx}`}
                                cardSize="small"
                                showGraphic={true}
                                maxLine={2}
                                minLine={1}
                                url={l}
                            />
                        )
                    })
                
            }

        </React.Fragment>
    )
};

BodyParser.propTypes = {
    postId: PropTypes.number.isRequired,
    body: PropTypes.string.isRequired,
    showPreview: PropTypes.bool
}

export default BodyParser;




// WEBPACK FOOTER //
// ./src/components/postComments/BodyParser.js